import { Component, Prop } from 'vue-property-decorator'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import LodashMixin from '@/_mixins/lodash'

@Component({
    mixins: [LodashMixin],
})
export default class EditorViewer extends Mixins<MixinInterface>(LodashMixin) {
    @Prop({ required: true }) description!: any
    @Prop({ default: true }) showImages!: boolean

    get descriptionObject() {
        let res: any = null

        if (this.description) {
            if (this.stringContainsJSON(this.description)) {
                let parsedInit = JSON.parse(this.description)
                if (parsedInit.type) {
                    if (parsedInit.type == 'editorjs') {
                        res = parsedInit.data
                    } else if (parsedInit.type == 'text') {
                        res = { blocks: [{ type: 'paragraph', data: { text: parsedInit.data } }] }
                    }
                } else {
                    res = parsedInit
                }
            } else {
                res = { blocks: [{ type: 'paragraph', data: { text: this.description } }] }
            }
        }

        return res
    }
}
